import styledTheme from 'common/theme';
import breakpoints from 'constants/breakpoints';
import styled from 'styled-components';

export const Container = styled.div<{ margin?: string }>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: 'wrap';

  margin: ${({ margin }) => margin};
  padding: 0.5rem 0;
  padding-bottom: 0;
  // max-width: 80%;
  margin: auto;
`;
export const StepItem = styled.div<{ color?: string }>`
  color: ${({ color }) => color || styledTheme.colors.grayDark};
  margin: 0 0.5rem;
`;
export const StepItemContent = styled.div`
  position: relative;
  text-align: center;
  display: flex;
  gap: 1rem;
  align-items: center;
  @media (max-width: ${breakpoints.size.lg}px) {
    margin-bottom: 0.5rem;
    gap: 0.5rem;
    .icon {
      width: 1.5rem;
    }
    p {
      font-size: 0.85rem;
    }
  }
`;

export const ProgressBar = styled.div<{ active?: boolean; isPrev?: boolean }>`
  flex: 1;
  height: 2px;
  background: ${({ isPrev, theme, active }) =>
    active
      ? theme.colors.lightGrey3
      : isPrev
      ? theme.colors.primaryBlue5
      : theme.colors.lightGrey3};
  border-radius: 0.17rem;
  margin: 2rem;
  max-width: 8%;
  @media (max-width: ${breakpoints.size.lg}px) {
    display: none;
  }
`;
export const IconContainer = styled.div<{ isActive?: boolean; isPrevious?: boolean }>`
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  background: ${({ isActive, isPrevious }) =>
    isPrevious
      ? styledTheme.bg.lightJBTblue
      : isActive
      ? styledTheme.JBTColors.mainColor
      : styledTheme.colors.gray200};
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: ${breakpoints.size.lg}px) {
    width: 1.75rem;
    height: 1.75rem;
    min-width: 1.75rem;
    min-height: 1.75rem;
  }
`;
export const SteppperBox = styled.div`
  border-bottom: 1px solid ${styledTheme.colors.gray300};
  margin: 0 2rem;
`;
